import cache from 'memory-cache';
import {getBinary} from "./apiUtils";

window.URL = window.URL || window.webkitURL;

// keep pictures for 2 hours.
const CACHE_TIMEOUT = 2 * 60 * 60 * 1000;

export const getUserLetter = (user) => {
  if (!user || !user.name) {
    return '';
  }
  const nameList = user.name.split(' ');
  let name = '';
  nameList.map(item => {
    name = name + item.charAt(0);
  });
  return name;
};

const CALLBACKS = {};

export default function updateImageData(user, callback) {
  if (!user) {
    return;
  }

  // check cache
  const cacheName = `photo-${user.oid}`;
  if (cache.get(cacheName)) {
    callback(cache.get(cacheName));
    return;
  }
  // check if a callback list and if so, add callback to array.
  let callbacklist = CALLBACKS[user.oid];
  if (!callbacklist) {
    CALLBACKS[user.oid] = [];
    callbacklist = CALLBACKS[user.oid];
    callbacklist.push(callback);
  } else {
    callbacklist.push(callback);
    return;
  }

  const newURL = `/users/${user.oid}/photo`;
  getBinary(newURL, 'get', null,
    (response) => {
    if (response) {
      const imageUrl = window.URL.createObjectURL(response);
      // add to cache
      cache.put(cacheName, imageUrl, CACHE_TIMEOUT);

      // handle callbacks.
      callbacklist.map(mappedCallback => mappedCallback(imageUrl));
      // remove callback list
      CALLBACKS[user.oid] = null;
    }
  }, (err) => {
      if (err.status !== 404) {
        console.log(err);
        callback(null);
        // remove from motion
        CALLBACKS[user.oid] = null;
      }
    });
};
